export { LoaderOverlayWrapperDS } from './loader-overlay-wrapper-ds'
export type { LoaderOverlayWrapperDSProps } from './loader-overlay-wrapper-ds.types'
